import * as core from '../../../../../../../core'

import { query } from './anticipated-response-of-change-by-functional-area.query'

export const RESOURCE = {
  payload: {
    alias: 'anticipated.response.of.change.by.functional.area',
    description:
      'Stacked bar chart of anticipated response of change by functional area',
    name: 'Anticipated Response of Change by Functional Area',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
